import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs'; import { environment } from 'src/environments/environment';
declare const io: any;

@Injectable({
  providedIn: 'root'
})
export class PushWebSocketService implements OnDestroy {
  private socket: any;
  private readonly socketNamespace = '/push'; // 🔹 Namespace separado no backend
  private readonly socketHost = environment.production ? 'slicksell.click' : 'stage.slicksell.click'; // ou stage.slicksell.click no stage

  connect(userId: number, token: string) {
    if (!userId) return;

    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    const socketUrl = `${protocol}${this.socketHost}${this.socketNamespace}`;

    this.socket = io(socketUrl, {
      query: { userId, token, is_admin: true }
    });

    this.socket.on('connect', () => {
      console.log('[PushWS] ✅ Conectado ao servidor de notificações');
    });

    this.socket.on('connect_error', (err: any) => {
      console.error('[PushWS] ❌ Erro de conexão', err);
    });

    this.socket.on('disconnect', (reason: string) => {
      console.warn('[PushWS] ⚠️ Desconectado', reason);
    });
  }

  listenNewPush(): Observable<any> {
    return new Observable(observer => {
      this.socket?.on('new-push', (pushData: any) => {
        console.log('[PushWS] 📩 Nova notificação recebida', pushData);
        observer.next(pushData);
      });
    });
  }

  listenNewMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket?.on('new-message', (msgData: any) => {
        console.log('[PushWS] 💬 Nova mensagem recebida', msgData);
        observer.next(msgData);
      });
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
